import { configureStore } from '@reduxjs/toolkit';
import { userReducer } from './store/userSlice';
import { snackbarReducer } from './store/snackbarSlice';
import { filterReducer } from './store/filterSlice';
import { reportFiltersReducer } from './store/reportFiltersSlice';
import { taskSortReducer } from './store/taskSortSlice';
import { setupListeners } from '@reduxjs/toolkit/query';
import { combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
const persistConfig = {
  key: 'root',
  storage: storage,
  // Snackbar notifications should not persist across sessions
  blacklist: ['snackbar'],
};
export const rootReducers = combineReducers({
  user: userReducer,
  snackbar: snackbarReducer,
  filter: filterReducer,
  reportFilters: reportFiltersReducer,
  taskSort: taskSortReducer,
});
const persistedReducer = persistReducer(persistConfig, rootReducers);
const store = configureStore({
  reducer: persistedReducer,
  middleware: dm =>
    dm({
      serializableCheck: {
        // Redux-persist actions contain non-serializable values
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
setupListeners(store.dispatch);
export const persistor = persistStore(store);
export default store;

export type RootState = ReturnType<typeof store.getState>;
